import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {
    $getSelection,
    $isRangeSelection,
    COMMAND_PRIORITY_HIGH,
    INDENT_CONTENT_COMMAND,
    OUTDENT_CONTENT_COMMAND
} from 'lexical';
import {useEffect} from 'react';

const commandCb = () => {
    const selection = $getSelection();
    if ($isRangeSelection(selection)) {
        const anchorNode = selection.anchor.getNode().getParent().getType() === 'listitem';
        if (anchorNode) {
            return true;
        }
    }
    return false;
};

export const DisableNestingPlugin = () => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        const removeIndentCommand = editor.registerCommand(
            INDENT_CONTENT_COMMAND,
            commandCb,
            COMMAND_PRIORITY_HIGH
        );

        const removeOutdentCommand = editor.registerCommand(
            OUTDENT_CONTENT_COMMAND,
            commandCb,
            COMMAND_PRIORITY_HIGH
        );

        return () => {
            removeIndentCommand();
            removeOutdentCommand();
        };
    }, [editor]);

    return null;
};
